<div class="revision-container">
  <!-- Header -->
  <div class="header-row">
    <div class="header-left">
      <span class="breadcrumb">Plan de Vida > <span class="breadcrumb-active">Revisión</span></span>
    </div>
  </div>

  <!-- Main content -->
  <div class="main-content">
    <!-- Page Header -->
    <div class="page-header">
      <h1 class="page-title">Revisión</h1>
      <p class="page-description">Tu plan de vida se construirá a partir de estas prioridades. Empieza por lo más importante para ti hoy.</p>
    </div>
    
    <!-- Save Button -->
    <div class="save-section" *ngIf="!rankingCompleted || isSaving">
      <button class="btn-save" (click)="savePriorities()" [disabled]="isSaving">
        <span *ngIf="isSaving">Guardando...</span>
        <span *ngIf="!isSaving">{{ allPrioritiesSelected ? 'Finalizar' : 'Guardar' }}</span>
      </button>
    </div>

    <!-- Completion Message -->
    <div class="completion-message" *ngIf="rankingCompleted">
      <div class="completion-icon">
        <i class="fas fa-check-circle"></i>
      </div>
      <div class="completion-text">
        <h3>¡Ranking Completado!</h3>
        <p>Has finalizado exitosamente el ranking de todas las áreas. Tus prioridades han sido guardadas.</p>
      </div>
    </div>
  </div>

  <!-- High Priority Table -->
  <div class="high-priority-section" *ngIf="highPriorityQuestions.length > 0">
    <div class="section-title-container">
      <h2 class="section-title">Prioridad ALTA</h2>
    </div>

    <div class="high-priority-table-container">
      <table class="high-priority-table">
        <thead>
          <tr>
            <th class="col-area">Área</th>
            <th class="col-gap hide-mobile">Brecha por cerrar</th>
            <th class="col-priority">Prioridad</th>
            <th class="col-ranking">Ranking</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of highPriorityQuestions" class="table-row">
            <td class="col-area">
              <span class="area-text">{{ item.question.name }}</span>
            </td>
            <td class="col-gap hide-mobile">
              <div class="gap-badge" [ngClass]="{
                'gap-low': item.gap <= 3,
                'gap-medium': item.gap > 3 && item.gap <= 6,
                'gap-high': item.gap > 6
              }">
                {{ item.gap }}
              </div>
            </td>
            <td class="col-priority">
              <div class="priority-badge">
                Alta
              </div>
            </td>
            <td class="col-ranking">
              <select 
                [ngModel]="getQuestionRanking(item.question)" 
                (ngModelChange)="updateQuestionRanking(item.question, $event)"
                [ngClass]="getRankingSelectClass(item.question)"
                [disabled]="rankingCompleted || inputsLocked">
                <option value="">Seleccionar</option>
                <option *ngFor="let option of getRankingOptionsForQuestion(item.question)" [value]="option">{{ option }}</option>
              </select>
              <div *ngIf="isRankingDuplicate(item.question)" class="ranking-error-message">
                Ranking duplicado
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <!-- Tips Phoenix Section -->
  <div class="tips-phoenix-section" *ngIf="highPriorityQuestions.length > 0">
    <div class="tips-container">
      <div class="tips-header">
        <div class="tips-title-wrapper">
          <h3 class="tips-title">Tips Phoenix</h3>
          <div class="tips-icon">
            <i class="fas fa-lightbulb"></i>
            <span class="notification-dot"></span>
          </div>
        </div>
      </div>
      <div class="tips-description">
        <p>Recuerda que estos consejos son para seguir avanzando en tu camino y comenzar a transformar tus reflexiones en acciones concretas.</p>
      </div>
      <ul class="tips-list">
        <li>Revisa y profundiza tu priorización: pregúntate qué quieres trabajar primero, cuánto impacto tendrá en tu vida y por qué es importante para ti hoy.</li>
        <li>Empieza a escribir tus objetivos preliminares según tus prioridades: define qué quieres lograr, en qué plazo y cómo sabrás que lo conseguiste.</li>
        <li>Da tu primer paso ahora: comienza a redactar tus objetivos y prepara la base de tu plan de vida, que luego pulirás junto a tu mentor <strong class="tips-highlight" (click)="navigateToObjectives()">AQUI</strong></li>
      </ul>
    </div>
  </div>

  <!-- Loading Message -->
  <div class="loading-state" *ngIf="isLoadingData">
    <div class="loading-content">
      <div class="loading-spinner"></div>
      <p>Cargando información...</p>
    </div>
  </div>

  <!-- No High Priority Message -->
  <div class="no-high-priority" *ngIf="!isLoadingData && highPriorityQuestions.length === 0 && tests.length > 0">
    <div class="empty-state">
      <i class="fas fa-info-circle"></i>
      <p>No hay prioridades marcadas como "Alta" aún.</p>
      <p class="sub-text">Dirígete al módulo de Ranking para clasificar tus áreas.</p>
    </div>
  </div>
</div>